import { Component, inject } from '@angular/core';
import { CurrencyPipe, CommonModule } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';

import { ReceivableSearchService } from '../receivable-search.service';
import { PaymentService } from '../payment.service';

import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatInputModule} from '@angular/material/input';
import { MatFormFieldModule} from '@angular/material/form-field';
import { MatSelectModule} from '@angular/material/select';
import { MatMenuModule } from '@angular/material/menu';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { PaymentParameters } from '../ebiz/domain/payment-parameters';
import { PaymentTransaction } from '../ebiz/domain/payment-transaction';
import { Account } from '@ohioepa/oepa-ebiz-lib';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'fee-payment-options',
  standalone: true,
  imports: [
    CurrencyPipe, CommonModule, MatFormFieldModule, MatInputModule, MatMenuModule,
    MatButtonModule, MatCardModule, MatSelectModule, MatDialogModule, MatGridListModule, MatProgressSpinnerModule
  ],
  templateUrl: './fee-payment-options.component.html',
  styleUrl: './fee-payment-options.component.css',
  providers: []
})
export class FeePaymentOptionsComponent {
  amountDueWithServiceFee: number = 0;
  paymentTransaction : PaymentTransaction;
  paymentParameters : PaymentParameters;
  readonly dialog = inject(MatDialog);
  serviceFeePct: string = '';
  public account: Account | undefined;
  private _snackBar = inject(MatSnackBar);
  
  constructor(
    private router: Router,
    private route: ActivatedRoute, 
    private receivableSearchService: ReceivableSearchService,
    private paymentService: PaymentService
  ) {
    this.retrieveServiceFeePct();
    this.paymentTransaction = this.paymentService.getPaymentTransaction()!;
    this.paymentParameters = this.paymentService.getPaymentParameters()!;
    this.account = this.paymentService.getAccount();
    if (this.paymentParameters?.totalAmountDue.amount && this.paymentParameters?.totalServiceFee.amount) {
      this.amountDueWithServiceFee = this.paymentParameters?.totalAmountDue.amount + this.paymentParameters?.totalServiceFee.amount;
    }
    
  }

  startOver() {
    this.receivableSearchService.clearReceivableList();
    this.router.navigate(['payment-home'], {queryParams: {uid: this.account?.userID}, relativeTo: this.route.parent});
  }

  isProcessingPayment = false;
  processPayment(paymentTypeCode: string) {
    this.isProcessingPayment = true;
    this.paymentService.retrieveFinalPaymentParametersForTransaction(this.paymentTransaction, paymentTypeCode).subscribe({
      next: paymentParameters => {
        window.location.href = paymentParameters.url;
      }, error: err => {
        this.isProcessingPayment = false;
        const message = err.error.message || err.message || JSON.stringify(err);
        this._snackBar.open(message, 'error', { panelClass: ['mat-toolbar', 'red-snackbar']});
      }
    }).add(() => {
      this.isProcessingPayment = false;
    });
  }

  retrieveServiceFeePct() {
     this.paymentService.getServiceFeePct().subscribe({
       next: parameter => {
         this.serviceFeePct = parameter.value;
       }, error: err => {
        const message = err.error.message || err.message || JSON.stringify(err);
        this._snackBar.open(message, 'error', { panelClass: ['mat-toolbar', 'red-snackbar']});
       }
     });
    //this.serviceFeePct = '1.9';
  }
}
